
class LoadMore extends HTMLElement { 
  constructor(){
    super();
    this.addEventListener("click", this.loadMoreItems);
  }

  loadMoreItems() { 
   
    const loadMoreBtn = this.querySelector('[type="button"]');
    loadMoreBtn.setAttribute("disabled", true);

    
    let { currentPage, pageSize, nextUrl, totalItems } = this.dataset
    let nextPage = parseInt(this.dataset.currentPage) + 1
    
    fetch(nextUrl.replace(/page=[0-9]+/,'page='+ nextPage))
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        $('#main-collection-product-grid').append($(html).find('#main-collection-product-grid').html());
        var datacurrentpage = $('.load-more_wrap').attr("data-current-page");
        var datacurrentpage = parseInt(datacurrentpage) + parseInt(1);
        var datatotalpage = $('.load-more_wrap').attr("data-total-pages");
        console.log(datatotalpage  + datacurrentpage );
        if (datacurrentpage == datatotalpage) {
          console.log("displaynoen");
          $('button.load-more_row.button.button--secondary.js-load-more').css('display','none');
        }
      }).catch((e) => {
        // handle error
        console.error(e);
      })
      .finally(() => {
        loadMoreBtn.removeAttribute("disabled");
        this.dataset.currentPage = parseInt(this.dataset.currentPage) + 1;
        
        let isLastPage = parseInt(totalItems) - (nextPage * parseInt(pageSize) ) < 0
        this.querySelector('[load-items-count]').innerHTML = isLastPage ? parseInt(totalItems) : nextPage * parseInt(pageSize)
        isLastPage && loadMoreBtn.setAttribute("disabled", true);
      });
  }
}

customElements.define('load-more', LoadMore);
$( document ).ready(function() {
  var datacurrentpage = $('.load-more_wrap').attr("data-current-page");
  var datatotalpage = $('.load-more_wrap').attr("data-total-pages");
  console.log(datatotalpage  + datacurrentpage );
  if (datacurrentpage == datatotalpage) {
    console.log("displaynoen");
    $('button.load-more_row.button.button--secondary.js-load-more').css('display','none');
  }

});